import React, { useEffect } from 'react';



import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import EarningsSection from './components/EarningsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ApplicationForm from './components/ApplicationForm';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import SimpleContactForm from './components/SimpleContactForm';

const LandingPage = () => {
  // Add onCtaClick handler function
  const handleCtaClick = () => {
    // Handle CTA click action - could scroll to form, open modal, etc.
    const contactForm = document.querySelector('#contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <HeroSection onCtaClick={handleCtaClick} />
      
      <SimpleContactForm />
      
      <ProblemSection />
      <SolutionSection />
      <EarningsSection />
      <TestimonialsSection />
      <ApplicationForm />
      <FAQSection />
      <Footer />
    </div>
  );
};

export default LandingPage;